/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordCounts } from "../../records/types/RecordCounts";
import { CellValue } from "../../records/types/CellValue";
export const CellValueWithCountsDeprecated = core.serialization
    .object({
    counts: RecordCounts.optional(),
})
    .extend(CellValue);
